import Helpers from '../Helpers'

new Helpers(document.getElementsByClassName('show-password')).eventListener((e) => {
    const passwordbox = new Helpers(e.target).getPrevious('input')
    if (passwordbox.type === 'text') { passwordbox.type = 'password' } else { passwordbox.type = 'text' }
    if (e.target.classList.contains('show-password--hide')) { e.target.classList.remove('show-password--hide') } else { e.target.classList.add('show-password--hide') }
})

new Helpers(document.getElementsByClassName('login-form-submit')).eventListener(() => {
    const passwordinputs = document.getElementsByClassName('password-input')
    for (let i = 0; i < passwordinputs.length; i += 1) {
        passwordinputs[i].type = 'password'
    }
})
const signUpContainer = document.querySelector('.form-section--accessOrCreate__create');
const signInContainer = document.querySelector('.form-section--accessOrCreate__signIn');
const createLink = document.querySelector('div.form-section--accessOrCreate__toggle-signin');
const loginLink = document.querySelector('div.form-section--accessOrCreate__toggle-create');

function toggleVisibility() {
    signUpContainer.classList.toggle('show');
    signInContainer.classList.toggle('show');
    createLink.classList.toggle('active');
    loginLink.classList.toggle('active');
}
new Helpers(loginLink).eventListener((e) => { 
    e.preventDefault();
    if (e.currentTarget.classList.contains('active') == false) {
        toggleVisibility();
    }
});

new Helpers(createLink).eventListener((e) => { 
    e.preventDefault();
    if (e.currentTarget.classList.contains('active') == false) {
        toggleVisibility();
    }
});
